/**
 * plugins/vuetify.ts
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import 'vuetify/styles';
// Include this line when using the pre-built Onex library.  Remove if using the components source.
import '@primerica/onex-ui-lib/onex-ui-lib.css';
import '@/assets/styles/main.scss';
import { aliases, mdi } from 'vuetify/iconsets/mdi';

import { vuetify } from '@primerica/onex-ui-lib';

vuetify.icons = {
  defaultSet: 'mdi',
  aliases,
  sets: {
    mdi,
  },
};

export default vuetify;
